import * as React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

export default function TemplateStep({
  templateState,
  setTemplateState,
  error,
  html,
}) {
  return (
    <Stack spacing={3}>
      <Typography
        variant="h5"
        gutterBottom
        component="div"
        sx={{ marginBottom: '10px', fontSize: '16px' }}
      >
        Create Template
      </Typography>

      <TextField
        id="template_name"
        label="Name"
        fullWidth
        value={templateState.name}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateState({
            ...templateState,
            name: event.target.value,
          });
        }}
        error={error.name ? true : false}
      />
      <FormControl fullWidth error={error.type ? true : false}>
        <InputLabel id="template_type_label">Type</InputLabel>
        <Select
          labelId="template_type_label"
          id="template_type"
          label="Type"
          value={templateState.type}
          onChange={event => {
            setTemplateState({
              ...templateState,
              type: event.target.value,
            });
          }}
        >
          <MenuItem value={'DEALER_VALUE'}>Dealer Value</MenuItem>
          <MenuItem value={'SINGLE_VEHICLE'}>Single Vehicle</MenuItem>
          <MenuItem value={'MULTIPLE_VEHICLES'}>Multiple Vehicle</MenuItem>
          <MenuItem value={'LEASE_VEHICLE'}>Lease Vehicle</MenuItem>
          <MenuItem value={'OEMV'}>OEM Value</MenuItem>
        </Select>
      </FormControl>

      <TextField
        id="template_subject"
        label="Subject"
        fullWidth
        value={templateState.subject}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTemplateState({
            ...templateState,
            subject: event.target.value,
          });
        }}
        error={error.subject ? true : false}
      />
      {html && (
        <TextField
          id="template_html"
          label="Html"
          fullWidth
          multiline
          minRows={5}
          maxRows={10}
          value={templateState.html}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setTemplateState({
              ...templateState,
              html: event.target.value,
            });
          }}
          error={error.html ? true : false}
        />
      )}
    </Stack>
  );
}
